import { AstraParagraph } from '~/astra'
import { Include, PractitionerScheduleStatusActivityLog } from '~/storm'
import { getInitials } from '~/utils/user'

import { ActivityLogWrapper } from './ActivityLogWrapper'
import { StatusLocationIcon } from './StatusLocationIcon'
import { formatDate, getActivityTypeLabel } from './utils'

type Props = {
    statusLogEntry: Include<PractitionerScheduleStatusActivityLog, { statusDefinition: true }>
}

export const PractitionerScheduleStatusActivityLogEntry = ({ statusLogEntry }: Props) => {
    const status = statusLogEntry.statusDefinition
    if (!status) return null
    const performedBy = statusLogEntry.performed_by ?? ''
    const initials = getInitials(performedBy)
    const activityTypeLabel = getActivityTypeLabel(statusLogEntry.activity_type)
    const performedAt = formatDate(statusLogEntry.performed_at)
    const icon = <StatusLocationIcon entity={status} activityType={statusLogEntry.activity_type} />

    return (
        <ActivityLogWrapper icon={icon} performedBy={performedBy} initials={initials} performedAt={performedAt}>
            <AstraParagraph variant="body">
                {activityTypeLabel} <span className="italic">{status.title}</span>
            </AstraParagraph>
        </ActivityLogWrapper>
    )
}
